define([], function () {
	function Init() {
		const controls = document.querySelectorAll('.hero-video--controls');

		controls.forEach((control) => {
			control.addEventListener('click', () => {
				var videoElement = control.parentElement.querySelector('video');
				var playButton = control.querySelector('.hero-video--controls-play');
				var pauseButton = control.querySelector('.hero-video--controls-pause');

				//Check if video is currently playing
				if ((videoElement.currentTime > 0
						&& !videoElement.paused
						&& !videoElement.ended
						&& videoElement.readyState > 2)) {
					videoElement.pause();
					$(playButton).show();
					$(pauseButton).hide();
				}
				else {
					videoElement.play();
					$(playButton).hide();
					$(pauseButton).show();
				}
			});
		});
	}

    return {
        Init: Init
    };
});